import React from "react";

const Button = ( {data} ) => {
    return(
        <button className="flex items-center gap-11 px-8 py-3 w-fit text-nowrap red-custom-button rounded-full lg:mt-4 md:mt-5 mt-4 leading-tight" onClick={() => window.location.replace(data.url_source)}>
            <span className="md:text-[20px] text-[16px] font-medium" style={{color: data.color}}>{data.text}</span>
            <img src={data.img} alt="?"/>
        </button>
    );
};
export default Button;